module.exports = __webpack_public_path__ + "img/img16.79c10b18.png";